export const resume = {
	title: "Summary",
	description:
		"Check that all the information is correct and then publish the promotion. It will automatically activate and be ready to use.",
	sections: {
		allProducts: "All products",
		andMore: "and more {{count}} products",
		promotionInfo: {
			title: "Promotion data",
			channel: "Channel",
			audience: "Who can receive this promotion",
			audienceValues: {
				everybody: "All customers",
				identifiedCpf: "Identified customers",
			},
			cpfPermissionWarning:
				"To identify customers on the ticket kiosk, the 'capture CPF on ticket kiosk' permission must be enabled.",
			name: "Name",
			description: "Description",
			maxUses: {
				label: "Quantities of uses per gain",
				uses: "{{uses}} uses",
				withoutLimits: "No Boundaries",
			},
			places: "Locations",
		},
		goals: {
			title: "Goals",
			frequency: "Recurrence of earnings",
		},
		awards: {
			title: "Awards",
			discount: "Discount(%) on the value of the product",
			products: "Discount products",
		},
		usageConditions: "Conditions of use",
	},
};
